import React from "react";

export default function Section1() {
  return (
    <div className="Section1 w-full h-[65vh] relative">
      <img
        className="absolute top-0 left-0 block object-cover w-full h-full object-center-center"
        src="assets/bg-news-and-pr.jpg"
        alt="News Background Image"
      ></img>
    </div>
  );
}
